export var TRANSLATIONS = {
    hr: {
        'label.searchFor': 'Tražiti',
        'label.selectType': 'Odaberite vrstu pretraživanja',
        'label.in': 'u',
        'label.location': 'Lokacija',
        'label.selectLocation': 'Odaberite mjesto',
        'label.button': 'Traži',
    },
    en: {
        'label.searchFor': 'Search for',
        'label.selectType': 'Select type of search',
        'label.in': 'in',
        'label.location': 'Location',
        'label.selectLocation': 'Select location',
        'label.button': 'Search',
    },
    de: {
        'label.searchFor': 'Suchen nach',
        'label.selectType': 'Wählen Sie die Art der Suche',
        'label.in': 'im',
        'label.location': 'Ort',
        'label.selectLocation': 'Ort auswählen',
        'label.button': 'Suche',
    },
    it: {
        'label.searchFor': 'Cercare',
        'label.selectType': 'Seleziona il tipo di ricerca',
        'label.in': 'nel',
        'label.location': 'Posizione',
        'label.selectLocation': 'Seleziona la posizione',
        'label.button': 'Ricerca',
    },
    hu: {
        'label.searchFor': 'Keresés',
        'label.selectType': 'A keresés típusának kiválasztása',
        'label.in': '',
        'label.location': 'Helység',
        'label.selectLocation': 'Helység kiválasztása',
        'label.button': 'Keresés',
    }
};
//# sourceMappingURL=tanslate.js.map